import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { TinyMceModule } from 'angular-tinymce';
import { tinymceDefaultSettings } from 'angular-tinymce';

import { TimoutDialogComponent } from './components/dialogs/timout-dialog/timout-dialog.component';
import { ModalComponent } from './components/modal/modal.component';
import { FieldComponent } from './components/field/field.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CellFieldComponent, HeaderFieldComponent, AttachmentLookupComponent } from './components/common';
import { AttachmentListComponent } from './components/list/attachment-list/attachment-list.component';
import { DataTableModule } from 'angular-4-data-table-bootstrap-4';
import { DialogComponent } from './components/common/dialog/dialog.component';
import { TinymceComponent } from './components/editors/tinymce/tinymce.component';
import { SliderComponent } from './components/common/slider/slider.component';
import { DataTableComponent } from './components/common/data-table/data-table.component';
import { TrapFocusDirective } from './directives/trap-focus-directive';
import { DropdownComponent } from './components/common/dropdown/dropdown.component';

//import { ArticleListComponent, ArticleMetaComponent, ArticlePreviewComponent } from './article-helpers';
//import { FavoriteButtonComponent, FollowButtonComponent } from './buttons';
//import { ListErrorsComponent } from './list-errors.component';
//import { ShowAuthedDirective } from './show-authed.directive';

@NgModule({
  imports: [
    NgbDropdownModule.forRoot(),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    RouterModule,
    TinyMceModule.forRoot(tinymceDefaultSettings()),
    DataTableModule
  ],
  declarations: [
    TimoutDialogComponent,
    ModalComponent,
    FieldComponent,
    CellFieldComponent,
    HeaderFieldComponent,
    AttachmentLookupComponent,
    AttachmentListComponent,
    DialogComponent,
    TinymceComponent,
    SliderComponent,
    DataTableComponent,
    TrapFocusDirective,
    DropdownComponent,
  ],
  exports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    HttpModule,
    RouterModule,
    NgbDropdownModule,
    FieldComponent,
    CellFieldComponent,
    HeaderFieldComponent,
    AttachmentLookupComponent,
    AttachmentListComponent,
    ModalComponent,
    TinymceComponent,
    SliderComponent,
    DialogComponent,
    DataTableComponent,
    DropdownComponent
  ],
  entryComponents: [
    ModalComponent,
    AttachmentLookupComponent,
    DialogComponent,
    TinymceComponent,
    SliderComponent,
    FieldComponent,
  ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/shared.module.ts